import * as React from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import moment from 'moment';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import { Close } from '@mui/icons-material';

export const CloseEOCCalender = ({
  handleChangeDate,
  value,
  disableDate,
  handleCloseCalendar,
}: any) => {
  const jsDate = moment(value, 'DD-MM-YYYY').toDate();
  const minSelectableDate = moment(disableDate).format('YYYY-MM-DD');
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-block',
      }}
    >
      <IconButton
        sx={{
          position: 'absolute',
          top: 20,
          right: '-10px',
          zIndex: 20,
          p: 1.5,
          marginTop: '-80px',
        }}
        onClick={handleCloseCalendar}
      >
        <Close />
      </IconButton>
      <DateCalendar
        sx={{
          boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
          position: 'absolute',
          background: '#fff',
          zIndex: 10,
          marginTop: '-60px',
          pt: 2.5,
          right: 0,
        }}
        minDate={new Date(minSelectableDate)}
        onChange={handleChangeDate}
      />
    </Box>
  );
};
